import { Chip } from "@mui/material";
import { getStatusChipColor } from "../constants/leadEnums";

const PartnerLeadStatusChip = ({ label, statusKey, size = "small" }) => (
  <Chip
    label={label || "—"}
    color={getStatusChipColor(statusKey)}
    size={size}
    variant={getStatusChipColor(statusKey) === "default" ? "outlined" : "filled"}
  />
);

export default PartnerLeadStatusChip;
